import GetProductsMapper from './DXP/GetProductsMapper'

export default {
  GetProductsMapper
}
